export default __webpack_public_path__ + "static/media/bg2.804bd096.jpg";